import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { ClientesService } from "../../../services/clientes.service";
/*App imports*/
import { HelpersService, TiposCreditos } from '../../../services/tools/helpers.service';
import { CreditosService } from "../../../services/creditos.service";

@Component({
  selector: 'formulario-cliente',
  templateUrl: './formulario-cliente.component.html'
})
export class FormularioClienteComponent implements OnInit {

  @Input() public idClientes: number = null;
  @Input() public idCreditos: number = null;
  @Input() public isCompleted: boolean = false;
  @Input() public isEditable: boolean = false;
  @Output() public onClientUpdated: EventEmitter<string> = new EventEmitter;
  //Cliente form
  public cliente: any = {};
  public errors: any = {};
  public showClaveElector: boolean = false;
  public tiposPersonas: any[] = [];
  public isLoading: boolean = false;
  public estadoPorDefecto: number = null;

  public estadoSelected: any = {};
  public OptEstados = [{ id: 1, nombre: "Aguascalientes" }, { id: 2, nombre: "Baja California" }, { id: 3, nombre: "Baja California Sur" }, { id: 4, nombre: "Campeche" },
  { id: 5, nombre: "Chiapas" }, { id: 6, nombre: "Chihuahua" }, { id: 7, nombre: "Ciudad de México" }, { id: 8, nombre: "Coahuila" }, { id: 9, nombre: "Colima" }, { id: 10, nombre: "Durango" }, { id: 11, nombre: "Estado de México" },
  { id: 12, nombre: "Guanajuato" }, { id: 13, nombre: "Guerrero" }, { id: 14, nombre: "Hidalgo" }, { id: 15, nombre: "Jalisco" }, { id: 16, nombre: "Michoacán" }, { id: 17, nombre: "Morelos" }, { id: 18, nombre: "Nayarit" }, { id: 19, nombre: "Nuevo León" },
  { id: 20, nombre: "Oaxaca" }, { id: 21, nombre: "Puebla" }, { id: 22, nombre: "Querétaro" }, { id: 23, nombre: "Quintana Roo" }, { id: 24, nombre: "San Luis Potosí" }, { id: 25, nombre: "Sinaloa" }, { id: 26, nombre: "Sonora" }, { id: 27, nombre: "Tabasco" },
  { id: 28, nombre: "Tamaulipas" }, { id: 29, nombre: "Tlaxcala" }, { id: 30, nombre: "Veracruz" }, { id: 31, nombre: "Yucatán" }, { id: 32, nombre: "Zacatecas" }];

  //Helpers
  private isInitialized: boolean = false;
  public tipoPersonaSelected: any = {};

  constructor(
    private clientesService: ClientesService,
    private helperService: HelpersService,
    private creditosService: CreditosService
  ) {
    this.tiposPersonas = [{ key: 'FISICA', label: 'Física' }, { key: 'MORAL', label: 'Moral' }];
  }

  public ngOnInit() {
  }

  public loadComponent() {
    if (!this.isInitialized) {
      this.getCliente(this.idClientes);
      this.isInitialized = true;
    }
  }

  private getCliente(idClientes) {
    this.isLoading = true;
    this.clientesService.get(idClientes).subscribe(
      (response) => {
        let cliente = response.json().content;
        this.cliente = cliente;
        this.selectTipoPersona(cliente.tipo_persona);
        this.selectEstado(cliente.estado);

        this.isLoading = false;
      }, error => {
      // se resuelve error 403 y 500
      this.helperService.httpGlobalError(error);

      if (error.status == 400) {
        this.setBackendErrors(error.json().content);
        this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
      }
      this.isLoading = false;
    }
    );
  }
  estadoChanged(estado) {
    if (estado && estado.id) {
      this.estadoSelected = estado;
      // GUARDAR SOLO EL ID (Número)
      this.cliente.estado = estado.id;
    } else {
      // Fallback si se limpia el select
      if (this.OptEstados && this.OptEstados.length > 0) {
        this.estadoSelected = this.OptEstados[0];
        this.cliente.estado = this.estadoSelected.id;
      }
    }
  }
  private selectEstado(estado) {
    // Buscamos el objeto que coincida ya sea con el ID o con el Nombre
    const encontrado = this.OptEstados.find(tipo =>
      tipo.id == estado || tipo.nombre === estado
    );

    if (encontrado) {
      this.estadoSelected = encontrado;
      // IMPORTANTE: Para el componente select2-single, actualiza también el default
      this.estadoPorDefecto = encontrado.id;
      // Guardamos solo el ID en el objeto cliente para evitar el "0" en la DB
      this.cliente.estado = encontrado.id;
    } else {
      // Fallback: si no encuentra nada, usa el primer estado
      this.estadoSelected = this.OptEstados[0];
      this.estadoPorDefecto = this.estadoSelected.id;
      this.cliente.estado = this.estadoSelected.id;
    }
  }
  public save() {
  
    this.errors = [];
    //En las validaciones el campo Clave de elector debe ser obligatorio
    this.errors = this.clientesService.validate(this.cliente);
    const idCliente = this.cliente.id;
    if (Object.keys(this.errors).length > 0) {
    console.warn("El guardado se detuvo por errores de validación:", this.errors);
    return false;
  }

    this.clientesService.update(idCliente, this.cliente ).subscribe(
      (response) => {
        const clientId = response.json().content;
        this.helperService.notification('Cliente actualizado', 'Se ha actualizado exitosamente la información del cliente ', 'success');
        this.onClientUpdated.emit();
      }, error => {
      // se resuelve error 403 y 500
      this.helperService.httpGlobalError(error);

      if (error.status == 400) {
        this.setBackendErrors(error.json().content);
        this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
      }
    }
    );
  }

  public onSelectedTipoPersona(tipoPersona: any) {
    this.tipoPersonaSelected = tipoPersona;
    this.cliente.tipo_persona = tipoPersona.key;
  }

  private selectTipoPersona(tipoPersona) {
    let component = this;
    this.tiposPersonas.forEach(function (tipo) {

      if (tipo.key === tipoPersona) {
        component.tipoPersonaSelected = tipo;
      }
    });
  }

  private setBackendErrors(errors: any[]) {
    let temp_errors = [];

    Object.keys(errors).forEach(function (key) {
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  formatearTelefono() {
    if (!this.cliente.telefono) return;

    let valor = this.cliente.telefono.replace(/\D/g, '').substring(0, 10);

    if (valor.length <= 3) {
      this.cliente.telefono = `(${valor}`;
    } else if (valor.length <= 6) {
      this.cliente.telefono = `(${valor.slice(0, 3)}) ${valor.slice(3)}`;
    } else {
      this.cliente.telefono = `(${valor.slice(0, 3)}) ${valor.slice(3, 6)}-${valor.slice(6)}`;
    }
  }

  limitarTelefono(event: KeyboardEvent) {
    const teclasPermitidas = [
      'Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'
    ];

    const esNumero = /^[0-9]$/.test(event.key);
    const valorActual = (this.cliente.telefono || '').replace(/\D/g, '');

    // Permitir teclas de control
    if (teclasPermitidas.includes(event.key)) {
      return;
    }

    // Bloquear si no es número
    if (!esNumero) {
      event.preventDefault();
      return;
    }

    // Bloquear si ya hay 10 dígitos
    if (valorActual.length >= 10) {
      event.preventDefault();
    }
  }


  validarPegado(event: ClipboardEvent) {
    event.preventDefault();

    const clipboardData = event.clipboardData || (window as any).clipboardData;
    let textoPegado = clipboardData.getData('text');

    let numerosPegados = textoPegado.replace(/\D/g, '');
    let actuales = (this.cliente.telefono || '').replace(/\D/g, '');

    const disponibles = 10 - actuales.length;
    numerosPegados = numerosPegados.slice(0, disponibles);

    this.cliente.telefono = actuales + numerosPegados;
    this.formatearTelefono();
  }



}



// WEBPACK FOOTER //
// ./src/app/creditos/components/formulario-cliente/formulario-cliente.component.ts